import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-077c9a75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "article" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titleLine" }, null, -1))
const _hoisted_3 = { class: "centent" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import { watch, computed } from "vue";
import store from "@/store";
import tableBox from "../tableBox.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'article',
  setup(__props) {

const appLanguage: any = computed(() => store.getters.getAppLanguage);
watch(
  () => appLanguage,
  () => {}
);

return (_ctx: any,_cache: any) => {
  const _component_SecondPageHeader = _resolveComponent("SecondPageHeader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SecondPageHeader, {
      class: "headerTitle",
      title: _ctx.$t('pointsMall.how'),
      toPath: "/pointsMall"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_unref(appLanguage) == 'en')
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t("pointsMall.text")), 1))
          : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t("pointsMall.text")), 1)),
        _createVNode(tableBox)
      ])
    ])
  ], 64))
}
}

})